import axios from 'axios';
import ServerCaller from './serverCall';

axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
axios.defaults.withCredentials = true;

export default new ServerCaller(axios);
export { axios as rawAxios };
